export default [
  { path: '/base/policies', name: 'BasePolicies', component: () => import(/* webpackChunkName: "base-policies" */ './index.vue') }
]